import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"

// accounts--statistics on `accounts_managements/accounts/accounts_statistics.html.haml`.
export default class extends Controller {
  static targets = ["statsTable"]

  static values = {
    ajaxUrl: String,
  }

  connect() {
    if (!this.hasStatsTableTarget) return
    this.#initStatsTable()
  }

  disconnect() {
    if (this.statsDataTable) {
      this.statsDataTable = destroyTurboDataTable(this.statsDataTable)
    }
  }

  #initStatsTable() {
    const controller = this

    this.statsDataTable = createTurboDataTable(this.statsTableTarget, {
      dom: '<"H"l<"updated_time">fr>t<ip>',
      scrollX: true,
      paging: true,
      order: [[6, "desc"]],
      stateSave: true,
      serverSide: true,
      processing: true,
      searchDelay: 2000,
      autoWidth: false,
      ajax: {
        url: this.ajaxUrlValue || "accounts_statistics",
      },
      drawCallback() {
        controller.#setUpdatedStatsTime()
      },
      columnDefs: [
        { targets: 0, width: "100px" },
        { targets: 1, width: "200px" },
        { targets: [0, 1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], searchable: false },
        { targets: [0, 1, 3, 4, 8, 9, 12], sortable: false },
      ],
    })
  }

  #setUpdatedStatsTime() {
    const json = this.statsDataTable.ajax.json()
    if (json?.updated_time) {
      $(".updated_time").html(`Updated stats time: ${json.updated_time}`)
    }
  }
}
